module.exports = __webpack_public_path__ + "static/media/demo.e6279e7a.gif";